export function findCep(cep) {
    var url = 'https://viacep.com.br/ws/' + cep + '/json/'
    const request = fetch(url);
    return request.then((response) => {
        return response.json();
    }).then((data) => {
        return data;
    })
}